import { LoadableAfterPaint } from '@confluence/loadable';
export {
	ISSUE_CREATE_SIDE_PANEL_ID,
	ISSUE_CREATE_SIDE_PANEL_WIDTH,
} from '../src/ui/single-work-create/IssueCreateSidePanel.tsx';
export const IssueCreateSidePanel = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-IssueCreateSidePanel" */ '../src/ui/single-work-create/IssueCreateSidePanel.tsx'
			)
		).IssueCreateSidePanel,
});
